export default "__VITE_ASSET__ZV$o21oa__"